import React from 'react'
import { Link } from 'react-router-dom'
import  './Navbar.css'
import { useStateValue } from './State'

function Navbar() {
    const [{cart},dispatch]=useStateValue()
     var now=new Date();
     var hour=now.getHours();
     var greet;
     if(hour<12)
     {
        greet="Good Morning"
     }
     else if(hour>=12)
     {
         hour-=12;
         if(hour<6)
         greet="Good Afternoon";
         if(hour>=6)
         greet="Good Evening";
     }
    return (
        
            <div className="navbar">
                <Link to="/">
                 <div className="logo link">{greet}</div>
                 </Link>
                <div className="search" >
                     <input type="text" className="inp" />
                     {    }
                     <button className="btn">Search</button>
                </div>
                <div className="icons">
                     <Link to="/login" className="link">
                     <div className="icons_sub">
                         <span className="line1">Hello</span>
                         <span className="line2">Sign In</span>
                     </div>
                     </Link>
                     <div className="icons_sub">
                         <span className="line1">Your</span>
                          <span className="line2">Orders</span>
                     </div>
                     <Link to="/cart" className="link">
                     <div className="icons_sub">
                           <span className="line1">View</span>
                           <span className="line2">Cart </span>
                     </div>
                     </Link>
                     <div className="num">
                         <span className="num1">{cart?.length}</span>
                     </div>
                </div>
            </div>
        
    )
}

export default Navbar
